import { Star } from 'lucide-react';
import { REVIEWS } from '../data/products';

export default function Reviews() {
  return (
    <section data-testid="reviews-section" className="section-padding bg-white">
      <div className="container-essenya">
        <div className="max-w-2xl mb-12">
          <div className="text-eyebrow mb-3">Recensioni clienti</div>
          <h2 className="text-4xl md:text-5xl font-display font-medium">Le parole di chi ha già scelto ESSENYA.</h2>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {REVIEWS.map((r, i) => (
            <div key={i} className="bg-essenya-bg rounded-xl p-6 border border-essenya-border" data-testid={`review-card-${i}`}>
              <div className="flex gap-1 mb-3">
                {Array.from({ length: r.stars }).map((_, j) => <Star key={j} size={14} strokeWidth={1.5} className="fill-essenya-ink text-essenya-ink" />)}
              </div>
              <p className="text-essenya-ink leading-relaxed mb-4">"{r.text}"</p>
              <div className="text-sm">
                <p className="font-medium">{r.name}</p>
                <p className="text-essenya-text text-xs">{r.product}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
